// @ts-check

/**
 * Event the form-aware registration wrapper dispatches from the native
 * `formDisabledCallback` so a component can react to its disabled state
 * (own attribute presence and ancestor `<fieldset disabled>`) without the
 * wrapper mutating the host.
 *
 * Kept in this dependency-free module so the registration layer can reference
 * it without importing the `useFormControl` composable (and its Vue/VueUse deps).
 */
export const FORM_DISABLED_EVENT = "sp:form-disabled";

/**
 * Event the wrapper dispatches from the native `formResetCallback` so a
 * component can restore the state its attributes describe when its form is
 * reset.
 */
export const FORM_RESET_EVENT = "sp:form-reset";
